import { HTMLAttributes, PropsWithChildren } from "react";

export interface BadgeProps
  extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  text?: string;
  color?: string;
  filled?: boolean;
  outline?: boolean;
  customShape?: boolean;
  weight?: number;
}

const Badge: React.FC<PropsWithChildren<BadgeProps>> = ({
  children,
  color,
  text,
  filled,
  outline = true,
  customShape = true,
  weight,
  ...rest
}) => {
  const badgeProps: any = {};
  color && (badgeProps["data-color"] = color);
  filled && (badgeProps["data-filled"] = "");
  customShape && (badgeProps["data-custom-shape"] = "");
  outline && !filled && (badgeProps["data-outline"] = "");

  return (
    <badge {...rest} {...badgeProps}>
      <text data-ellipsis="" data-weight={`${weight ?? 600}`}>
        {text || children} {/* NOSONAR */}
      </text>
    </badge>
  );
};

export default Badge;
